import { render } from "./index.vue?vue&type=template&id=2e5b54e8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2e5b54e8&lang=css"
script.render = render

export default script